<template>
    <div>
        <encabezado-filtros
            titulo="Pagos"
            :subtitulo="`Total recaudado: $${totalPagos}`"
            v-model:busqueda="busqueda"
            placeholder-busqueda="Buscar por nombre o matrícula"
        >
            <template v-slot:acciones>
                <v-btn color="primary" to="/registrar-visita">
                    <v-icon start>mdi-cash-plus</v-icon>
                    Registrar pago
                </v-btn>
            </template>

            <template v-slot:filtros>
                <periodo-busqueda @buscar="onBuscar"/>
            </template>
        </encabezado-filtros>

        <cartas-totales v-if="pagos.length > 0" class="mt-3" :totales="totalesMembresias" :titulo="'Pagos realizados por membresía'" :icono="'mdi-currency-usd'" :color="'deep-orange darken-1'" />

        <v-card variant="outlined" rounded="lg" class="mt-3">
            <v-data-table
            :loading="cargando"
            :headers="encabezadoTabla"
            :items="pagos"
            :search="busqueda"
            sort-by="nombre"
            :footer-props="{itemsPerPageText: 'Por página'}"
            >
                <template v-slot:[`item.nombre`]="{ item }">
                    <div class="d-flex align-center py-1" style="gap: 12px">
                        <v-avatar size="38">
                            <v-img v-if="item.imagen" :src="urlImagen(item.imagen)" alt="Foto"></v-img>
                            <v-icon v-else>mdi-account</v-icon>
                        </v-avatar>
                        <div>
                            <div class="font-weight-medium">{{ item.nombre }}</div>
                            <div class="text-caption text-muted">Matrícula {{ item.matricula }}</div>
                        </div>
                    </div>
                </template>

                <template v-slot:no-data>
                    <v-alert color="error" icon="warning">
                        No se han encontrado datos :(
                    </v-alert>
                    </template>
            </v-data-table>
        </v-card>

        <cartas-totales v-if="pagos.length > 0" class="mt-3" :totales="totalesUsuarios" :titulo="'Pagos realizados por usuario'" :icono="'mdi-account-cash'" :color="'green darken-3'" />

        <cartas-totales-miembros v-if="pagos.length > 0" class="mt-3" :totales="totalesMiembros" :titulo="'Pagos realizados por miembros'"  />

        <v-overlay :model-value="cargando">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import PeriodoBusqueda from '../Dialogos/PeriodoBusqueda.vue'
import CartasTotales from '../Dialogos/CartasTotales.vue'
import CartasTotalesMiembros from '../Dialogos/CartasTotalesMiembros.vue'
import EncabezadoFiltros from '../Dialogos/EncabezadoFiltros.vue'

export default {
    name: "Pagos",
    components: { PeriodoBusqueda, CartasTotales, CartasTotalesMiembros, EncabezadoFiltros },
    data:()=>({
        busqueda: "",
        cargando: false,
        pagos: [],
        encabezadoTabla: [
            {title: "Miembro", sortable: true, key: "nombre"},
            {title: "Fecha", sortable: true, key: "fecha"},
            {title: "Monto pagado", sortable: true, key: "monto"},
            {title: "Membresía pagada", sortable: true, key: "membresia"},
            {title: "Cobró", sortable: true, key: "usuario"},
            ],
        filtros: {
            fechaInicio: null,
            fechaFin: null
        },
        totalPagos: 0,
        totalesMembresias: [],
        totalesUsuarios: [],
        totalesMiembros: []
    }),

    mounted(){
        this.obtenerPagos()
    },

    methods: {
        onBuscar(fechas){
            console.log(fechas)
            this.filtros = {
                fechaInicio: fechas[0],
                fechaFin: fechas[1]
            }

            this.obtenerPagos()
        },

        urlImagen(imagen){
            return Utiles.generarURL(imagen)
        },

        obtenerPagos(){
            this.cargando = true
            let payload = {
                metodo: 'obtener',
                filtros: this.filtros
            }
            HttpService.obtenerConDatos(payload, 'pagos.php')
            .then(respuesta => {
                this.pagos = respuesta.pagos
                this.totalPagos = respuesta.totalPagos
                this.totalesMembresias = respuesta.totalesMembresias
                this.totalesUsuarios = respuesta.totalesUsuario
                this.totalesMiembros = respuesta.totalesMiembros
                console.log(respuesta)
                this.cargando = false
            })

        }
    }
}
</script>
